import { Link } from "react-router-dom";
import DealerVerificationBadge from "../DealerVerificationBadge";
import { buildDealerInitials } from "../../../clientViewRuntime/templates/dealerPublic/dealerProfileUtils";
import { getDealerProfileHref } from "../../../utils/dealerProfile";
import { trackSeoPageEvent, SEO_ANALYTICS_EVENTS } from "../../../constants/seoAnalyticsConstants";

export default function SeoDealerCityModule({ city, citySlug, dealers = [], loading = false }) {
  if (!city) return null;

  return (
    <section className="seo-dealer-city" aria-labelledby="seo-dealer-city-heading">
      <h2 id="seo-dealer-city-heading">Concesionarios en {city}</h2>
      <p>
        Perfiles con inventario activo en AutoMapa. “Verificado” indica revisión básica del negocio y contacto, no
        garantía sobre cada vehículo.
      </p>
      <p>
        <Link to="/guias/compra-segura" onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.GUIDE_CTA_CLICKED, { guide: "compra-segura" })}>
          Guía de compra segura
        </Link>
        {" · "}
        <Link to="/carros-usados-medellin">Ver carros usados en {city}</Link>
      </p>

      {loading ? <p className="seo-inventory__status">Cargando concesionarios…</p> : null}

      {!loading && dealers.length ? (
        <ul className="seo-dealer-city__list">
          {dealers.map((dealer) => (
            <li key={dealer.id}>
              <article className="seo-dealer-city__card">
                <div className="seo-dealer-city__card-top">
                  <span className="seo-inventory-card__avatar">{buildDealerInitials(dealer)}</span>
                  <div>
                    <h3>{dealer.businessName}</h3>
                    <p>{dealer.city || city}</p>
                  </div>
                </div>
                <p className="seo-dealer-city__meta">{dealer.activeListingCount ?? 0} vehículos activos</p>
                <DealerVerificationBadge dealer={dealer} size="small" variant="card" context="card" />
                <div className="seo-dealer-city__actions">
                  {dealer.slug ? (
                    <Link
                      to={getDealerProfileHref(dealer) || "#"}
                      className="seo-btn seo-btn--secondary"
                      onClick={() =>
                        trackSeoPageEvent(SEO_ANALYTICS_EVENTS.DEALER_PROFILE_CLICKED, {
                          dealerId: dealer.id,
                          citySlug,
                        })
                      }
                    >
                      Ver perfil
                    </Link>
                  ) : null}
                </div>
              </article>
            </li>
          ))}
        </ul>
      ) : null}

      {!loading && !dealers.length ? (
        <p>Explora el directorio nacional mientras ampliamos perfiles en {city}.</p>
      ) : null}

      <Link
        to="/v/automap/concesionarios"
        className="seo-dealers__directory"
        onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.DEALER_CLICKED, { source: "dealer_city_directory" })}
      >
        Directorio de concesionarios →
      </Link>
    </section>
  );
}
